const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Add+BI+Rewards+to+Cart+API

function addBiRewardsToCart(skuId) {
    const url = '/api/bi/profile/rewards?includeBasket=true';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ biRewards: [skuId] })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = addBiRewardsToCart;
